import PlusPlain from 'svg/PlusPlain';
import classNames from 'styles/utils/classNames';

/**
 * Figma uses one placeholder for every empty section and only varies its height,
 * so the sizes are named for the section shape rather than restating pixels:
 * `auto` hugs its content (the socials row), `md` is a text block, `lg` is a
 * media block (gallery, map).
 */
type PlaceholderSize = 'auto' | 'md' | 'lg';

const SIZES: Record<PlaceholderSize, string> = {
  auto: 'w-auto',
  md: 'h-20 w-full',
  lg: 'h-[14.25rem] w-full',
};

interface Props {
  label: string;
  onClick?: () => void;
  size?: PlaceholderSize;
  className?: string;
}

/** The owner-only "add something here" prompt. Visitors never see it — sections
 *  drop out entirely when empty, which `ProfileSection` handles. */
export default function EmptyAddPlaceholder({
  label,
  onClick,
  size = 'md',
  className,
}: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        'typography-product-button-label-small inline-flex items-center justify-center gap-ds-xs rounded-lg border border-dashed border-color-border-input-lightmode bg-color-bg-lightmode-tertiary px-8 py-1 text-color-text-brand dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-tertiary',
        SIZES[size],
        className,
      )}
    >
      <PlusPlain className="h-3.5 w-3.5 shrink-0" />
      <span>{label}</span>
    </button>
  );
}
